// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"99":"component---themes-gatsby-theme-beluga-src-templates-index-tsx","389":"component---themes-gatsby-theme-beluga-src-pages-404-tsx"}[chunkId] || chunkId) + "-" + {"36":"cf428756790da56c9334","99":"8a45ffbac5fdb50997f0","389":"31c26c9705aab5664da1","466":"95f77fb79942b4c5db46"}[chunkId] + ".js";
};